// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_editor_view_options(props) {
  var onClose = props.onClose;
  var onSmallBtnsChange = props.onSmallBtnsChange;
  var smallBtns = props.smallBtns;
  var onInlineModeChange = props.onInlineModeChange;
  var inlineMode = props.inlineMode;
  var onShowJstfChange = props.onShowJstfChange;
  var showJstf = props.showJstf;
  var onShowTypeChange = props.onShowTypeChange;
  var showType = props.showType;
  var onShowLabelChange = props.onShowLabelChange;
  var showLabel = props.showLabel;
  var onShowCheckboxChange = props.onShowCheckboxChange;
  var showCheckbox = props.showCheckbox;
  var match = React.useState(function () {
        return showCheckbox;
      });
  var setShowCheckbox = match[1];
  var showCheckbox$1 = match[0];
  var match$1 = React.useState(function () {
        return showLabel;
      });
  var setShowLabel = match$1[1];
  var showLabel$1 = match$1[0];
  var match$2 = React.useState(function () {
        return showType;
      });
  var setShowType = match$2[1];
  var showType$1 = match$2[0];
  var match$3 = React.useState(function () {
        return showJstf;
      });
  var setShowJstf = match$3[1];
  var showJstf$1 = match$3[0];
  var match$4 = React.useState(function () {
        return inlineMode;
      });
  var setInlineMode = match$4[1];
  var inlineMode$1 = match$4[0];
  var match$5 = React.useState(function () {
        return smallBtns;
      });
  var setSmallBtns = match$5[1];
  var smallBtns$1 = match$5[0];
  React.useEffect((function () {
          Curry._1(onShowCheckboxChange, showCheckbox$1);
        }), [showCheckbox$1]);
  React.useEffect((function () {
          Curry._1(onShowLabelChange, showLabel$1);
        }), [showLabel$1]);
  React.useEffect((function () {
          Curry._1(onShowTypeChange, showType$1);
        }), [showType$1]);
  React.useEffect((function () {
          Curry._1(onShowJstfChange, showJstf$1);
        }), [showJstf$1]);
  React.useEffect((function () {
          Curry._1(onInlineModeChange, inlineMode$1);
        }), [inlineMode$1]);
  React.useEffect((function () {
          Curry._1(onSmallBtnsChange, smallBtns$1);
        }), [smallBtns$1]);
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, React.createElement("span", {
                            style: {
                              fontSize: "1.1em",
                              fontWeight: "bold"
                            }
                          }, "View Options"), React.createElement(Button, {
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              }),
                            children: "Close"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showCheckbox$1,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool((function (b) {
                                                    Curry._1(setShowCheckbox, (function (param) {
                                                            return b;
                                                          }));
                                                  }), param);
                                    })
                                }),
                            label: "Checkbox"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showLabel$1,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool((function (b) {
                                                    Curry._1(setShowLabel, (function (param) {
                                                            return b;
                                                          }));
                                                  }), param);
                                    })
                                }),
                            label: "Label"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showType$1,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool((function (b) {
                                                    Curry._1(setShowType, (function (param) {
                                                            return b;
                                                          }));
                                                  }), param);
                                    })
                                }),
                            label: "Step type"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showJstf$1,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool((function (b) {
                                                    Curry._1(setShowJstf, (function (param) {
                                                            return b;
                                                          }));
                                                  }), param);
                                    })
                                }),
                            label: "Justification"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: inlineMode$1,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool((function (b) {
                                                    Curry._1(setInlineMode, (function (param) {
                                                            return b;
                                                          }));
                                                  }), param);
                                    })
                                }),
                            label: "Compact mode"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: smallBtns$1,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool((function (b) {
                                                    Curry._1(setSmallBtns, (function (param) {
                                                            return b;
                                                          }));
                                                  }), param);
                                    })
                                }),
                            label: "Small buttons"
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              }),
                            children: "Close"
                          })))
            });
}

var make = MM_cmp_editor_view_options;

exports.make = make;
/* react Not a pure module */
